module.exports = __webpack_public_path__ + "static/heidi10-2e4bd0389be73c1241602ecedd0443cb.jpg";